module.exports = __webpack_public_path__ + "img/pubCeritaUntungs.4798c9ed.webp";